import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class DeleteArbetsorderRestriktionCommand extends BasicCommand<DeleteArbetsorderRestriktionCommand> {

    get primaryKey(): IPrimaryKey<DeleteArbetsorderRestriktionCommand> {
        return {
            arbetsorderId: this.arbetsorderId,
            typ: this.typ
        };
    }
    arbetsorderId: number;
    typ: string;
    static readonly $type = "DeleteArbetsorderRestriktionCommand";
    constructor(arbetsorderId: number, typ: string) {
        super(DeleteArbetsorderRestriktionCommand.$type,"Arbetsorder", CommandType.Delete);
        this.arbetsorderId = arbetsorderId;
        this.typ = typ;
    }
}
